
    // IMPORTS
    import { computed, defineComponent } from 'vue'
    import { useRoute } from 'vue-router'

    import PortalPage from '@/components/common/portal-page.vue'
    import SparepartView from '@/components/spareparts/sparepart-view.vue'

    import { DbConstants } from '@/const'
    import { buildClassificationLocalization, buildLocalization } from '@/util'

    export default defineComponent({
        name: 'modelSpareParts',

        components: {
            PortalPage,
            SparepartView
        },

        setup() {
            /********************************************************************************************************************
             PRIVATE DATA
             ********************************************************************************************************************/
            const route = useRoute()
            const { localize } = buildLocalization()
            const { localizePropValueHierarchy } = buildClassificationLocalization()

            /********************************************************************************************************************
             PUBLIC DATA
             ********************************************************************************************************************/
            const publicData = {}

            /********************************************************************************************************************
             COMPUTED DATA
             ********************************************************************************************************************/
            const model = computed(() => (route.params.model as string)?.toUpperCase())
            const modelName = computed(() => localizePropValueHierarchy(
                DbConstants.sparePartPropertyNames.sparePartModel,
                model.value)
                .join(' - ')
            )

            const pageTitle = computed(() => `${localize('spareParts')}: ${modelName.value}`)
            const computedData = { model, pageTitle }

            /********************************************************************************************************************
             PUBLIC METHODS
             ********************************************************************************************************************/
            const publicMethods = {}

            /********************************************************************************************************************
             COMPONENT INTERFACE
             ********************************************************************************************************************/
            return { ...publicData, ...computedData, ...publicMethods }
        }
    });
